import { GOOGLE_OUS_COMING_SOON_NOTIFY_ME_ON_LAUNCH_LINK } from '../../common/constants/constants'
import { CMS_MICROSITE_MESSAGE_KEY } from '../messages/messages'
import { CMS_MICROSITE_ID, CMSMicrositeMetadata } from '../types'

export const googleOUSComingSoonMetadata: CMSMicrositeMetadata = {
  micrositeId: CMS_MICROSITE_ID.GOOGLE_OUS_COMING_SOON,
  iFrameSrcUrl: '/comingSoon',
  micrositeUrl: 'comingSoon',
  title: {
    id: 'googleOUSComingSoonMicrosite.title',
    defaultMessage: 'Coming soon: Enhanced mental health support for every Googler, everywhere',
    description: 'Microsite page title',
  },
  customerPropertyConditions: [],
  featureFlag: 'googleOUSComingSoonMicrositeEnabled',
  postMessageEvents: [
    {
      key: CMS_MICROSITE_MESSAGE_KEY.OPEN_EXTERNAL_LINK,
      params: { link: GOOGLE_OUS_COMING_SOON_NOTIFY_ME_ON_LAUNCH_LINK },
    },
  ],
  trackUTMParams: {
    utm_campaign: 'GoogleOUS',
  },
  page: 'GoogleOUS',
  shouldSupportSpanish: false,
  shouldHideForInternational: false,
}
